import { render, staticRenderFns } from "./SetupWifiCredentials.vue?vue&type=template&id=070c9e2e&"
import script from "./SetupWifiCredentials.vue?vue&type=script&lang=js&"
export * from "./SetupWifiCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports